import React from "react"
import PropTypes from "prop-types";
import { HTMLSelect, Label, FormGroup } from "@blueprintjs/core"
import { Alert } from "react-bootstrap";

// OTA Files configurations located inside App Params (both Sensor and Gateway)
export default function OTADialog (props) {
    // Function to extract the name of the OTA files
    function otaNameExtration(obj){
        let regex;
        if(obj.type === 'NEURAL_NETWORK'){
            regex = /.*nns\/(\S+)$/;
        } else if(obj.type === 'NODE_FIRMWARE'){
            regex = /.*palladium-fws\/(\S+)$/;
        } else if (obj.type === 'WISUN_FIRMWARE'){
            regex = /.*wisun_fws\/(\S+)$/
        } else if (obj.type === 'GATEWAY_SCRIPT'){
            regex = /.*gateway-scripts\/(\S+)$/
        }

        const match = obj.url.match(regex);

        if(match){
            // obj['name'] = match[1]
            return match[1]
        } else{
            // obj['name'] = obj.url
            return obj.url
        }
    }

    if (props.hierarchy){
        return <>
            <p><b>Sensor Settings</b></p>
            {props.nodeFirmware ? 
                <FormGroup style={{marginBottom:'1rem'}}>
                    <Label htmlFor={`input-ota-node-fw`}>
                        Node Firmware
                    </Label>
                    <HTMLSelect
                        id={`input-ota-node-fw`}
                        name='setNodeFirmwareId'
                        value={props.currentOTA.setNodeFirmwareId || 0}
                        fill={true}
                        options={[
                            ...props.nodeFirmware.map(file => ({
                                value: `${file.id}`,
                                label: `${otaNameExtration(file)}`,
                            })),
                            { value: 0, label: 'Unset' }
                        ]}
                        onChange={props.onOTAChange}
                    />
                </FormGroup>
            : null}
                {props.neuralNetwork ? 
                <FormGroup style={{marginBottom:'1rem'}}>
                    <Label htmlFor={`input-ota-neural-network`}>
                        Neural Network
                    </Label>
                    <HTMLSelect
                        id={`input-ota-neural-network`}
                        name='setNeuralNetworkId'
                        value={props.currentOTA.setNeuralNetworkId || 0}
                        fill={true}
                        options={[...props.neuralNetwork.map(file => ({
                            value: `${file.id}`,
                            label: `${otaNameExtration(file)}`
                            })),
                            { value: 0, label: 'Unset' }
                        ]}
                        onChange={props.onOTAChange}
                    />
                </FormGroup>        
            : null}
            {props.sensorWisunFirmware ?
                <FormGroup style={{marginBottom:'1rem'}}>
                    <Label htmlFor={`input-ota-wisun-fw`}>
                        Sensor Wisun Firmware
                    </Label>
                    <HTMLSelect
                        id={`input-ota-wisun-fw`}
                        name='setNodeWisunFirmwareId'
                        value={props.currentOTA.setNodeWisunFirmwareId || 0}
                        fill={true}
                        options={[...props.sensorWisunFirmware.map(file => ({
                            value: `${file.id}`,
                            label: `${otaNameExtration(file)}`
                            })),                         
                            { value: 0, label: 'Unset' }
                        ]}
                        onChange={props.onOTAChange}
                    />
                </FormGroup>             
            : null}
            {(props.gatewayWisunFirmware || props.gatewayScript) ? <p><b>Gateway Settings</b></p> : null}
            {props.gatewayWisunFirmware ?
                <FormGroup style={{marginBottom:'1rem'}}>
                    <Label htmlFor={`input-ota-wisun-fw`}>
                        Gateway Wisun Firmware
                    </Label>
                    <HTMLSelect
                        id={`input-ota-wisun-fw`}
                        name='setGatewayWisunFirmwareId'
                        value={props.currentOTA.setGatewayWisunFirmwareId || 0}
                        fill={true}
                        options={[...props.gatewayWisunFirmware.map(file => ({
                            value: `${file.id}`,
                            label: `${otaNameExtration(file)}`
                            })),                         
                            { value: 0, label: 'Unset' }
                        ]}
                        onChange={props.onOTAChange}
                    />
                </FormGroup>             
            : null}
            {props.gatewayScript ? 
                <FormGroup style={{marginBottom:'1rem'}}>
                    <Label htmlFor={`input-ota-gateway-script`}>
                        Gateway Script
                    </Label>
                    <HTMLSelect
                        id={`input-ota-gateway-script`}
                        name='setGatewayScriptId'
                        value={props.currentOTA.setGatewayScriptId || 0}
                        fill={true}
                        options={[...props.gatewayScript.map(file => ({
                            value: `${file.id}`,
                            label: `${otaNameExtration(file)}`
                            })),                         
                            { value: 0, label: 'Unset' }
                        ]}
                        onChange={props.onOTAChange}
                    />
                </FormGroup>   
            : null}
        </>
    } else{
        return<>
            {props.nodeFirmware ? 
                <FormGroup style={{marginBottom:'1rem'}}>
                    <Label htmlFor={`input-ota-node-fw`}>
                        Node Firmware
                    </Label>
                    <HTMLSelect
                        id={`input-ota-node-fw`}
                        name='nodeFirmwareId'
                        value={props.currentOTA.nodeFirmwareId === null ? -1 : props.currentOTA.nodeFirmwareId}
                        fill={true}
                        options={[
                            ...props.nodeFirmware.map(file => ({
                                value: `${file.id}`,
                                label: `${otaNameExtration(file)}`,
                            })),
                            { value: 0, label: 'No Updates' },
                            { value: -1, label: 'Unset' }
                        ]}
                        onChange={props.onOTAChange}
                    />
                </FormGroup>
            : null}
            {props.neuralNetwork ? 
                <FormGroup style={{marginBottom:'1rem'}}>
                    <Label htmlFor={`input-ota-neural-network`}>
                        Neural Network
                    </Label>
                    <HTMLSelect
                        id={`input-ota-neural-network`}
                        name='neuralNetworkId'
                        value={props.currentOTA.neuralNetworkId === null ? -1 : props.currentOTA.neuralNetworkId}
                        fill={true}
                        options={[...props.neuralNetwork.map(file => ({
                            value: `${file.id}`,
                            label: `${otaNameExtration(file)}`
                            })),
                            { value: 0, label: 'No Updates' },
                            { value: -1, label: 'Unset' }
                        ]}
                        onChange={props.onOTAChange}
                    />
                </FormGroup>        
            : null}
            {props.sensorWisunFirmware ?
                <FormGroup style={{marginBottom:'1rem'}}>
                    <Label htmlFor={`input-ota-wisun-fw`}>
                        Sensor Wisun Firmware
                    </Label>
                    <HTMLSelect
                        id={`input-ota-wisun-fw`}
                        name='wisunFirmwareId'
                        value={props.currentOTA.wisunFirmwareId === null ? -1 : props.currentOTA.wisunFirmwareId}
                        fill={true}
                        options={[...props.sensorWisunFirmware.map(file => ({
                            value: `${file.id}`,
                            label: `${otaNameExtration(file)}`
                            })),                         
                            { value: 0, label: 'No Updates' },
                            { value: -1, label: 'Unset' }
                        ]}
                        onChange={props.onOTAChange}
                    />
                </FormGroup>             
            : null}
            {props.gatewayWisunFirmware ?
                <FormGroup style={{marginBottom:'1rem'}}>
                    <Label htmlFor={`input-ota-wisun-fw`}>
                        Gateway Wisun Firmware
                    </Label>
                    <HTMLSelect
                        id={`input-ota-wisun-fw`}
                        name='wisunFirmwareId'
                        value={props.currentOTA.wisunFirmwareId === null ? -1 : props.currentOTA.wisunFirmwareId}
                        fill={true}
                        options={[...props.gatewayWisunFirmware.map(file => ({
                            value: `${file.id}`,
                            label: `${otaNameExtration(file)}`
                            })),                         
                            { value: 0, label: 'No Updates' },
                            { value: -1, label: 'Unset' }
                        ]}
                        onChange={props.onOTAChange}
                    />
                </FormGroup>             
            : null}
            {props.gatewayScript ? 
                <FormGroup style={{marginBottom:'1rem'}}>
                    <Label htmlFor={`input-ota-gateway-script`}>
                        Gateway Script
                    </Label>
                    <HTMLSelect
                        id={`input-ota-gateway-script`}
                        name='gatewayScriptId'
                        value={props.currentOTA.gatewayScriptId === null ? -1 : props.currentOTA.gatewayScriptId}
                        fill={true}
                        options={[...props.gatewayScript.map(file => ({
                            value: `${file.id}`,
                            label: `${otaNameExtration(file)}`
                            })),                         
                            { value: 0, label: 'No Updates' },
                            { value: -1, label: 'Unset' }
                        ]}
                        onChange={props.onOTAChange}
                    />
                </FormGroup>   
            : null}
            <Alert variant="info">
                <b>Note:</b> Choosing <b>&apos;No Updates&apos;</b> or a specific version indicates that the device will not receive hierarchical software updates (OTAs) from the organization or its designated zone.
            </Alert>
        </>
    }
}

OTADialog.propTypes = {
    nodeFirmware: PropTypes.array,
    neuralNetwork: PropTypes.array,
    gatewayWisunFirmware: PropTypes.array,
    sensorWisunFirmware: PropTypes.array,
    gatewayScript: PropTypes.array,
    currentOTA: PropTypes.object,
    onOTAChange: PropTypes.func,
    hierarchy: PropTypes.bool
}